import { render, staticRenderFns } from "./ComplaintModal.vue?vue&type=template&id=50a99c32&"
import script from "./ComplaintModal.vue?vue&type=script&lang=js&"
export * from "./ComplaintModal.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintModal.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports